// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.red[data-v-37009a82] {
  color: darkred;
}
.green[data-v-37009a82] {
  color: darkgreen;
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-bool.vue","webpack://./np-bool.vue"],"names":[],"mappings":"AACI;EACI,cAAA;ACAR;ADGI;EACI,gBAAA;ACDR","sourcesContent":["\n    .red {\n        color: darkred;\n    }\n\n    .green {\n        color: darkgreen;\n    }\n",".red {\n  color: darkred;\n}\n.green {\n  color: darkgreen;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
